
import React, {Component, useState, useEffect} from 'react';

const CLS = 'reactDropDownMulti';

const ReactDropDownMulti = (props) => {
	const {
		options,
		onSelect,
		title,
	} = props;
	const [active, setActive] = useState(false);

	return (
		<div className={`${CLS} mr-1`}>
			<div className={`${CLS}-dropdown dropdown`}>
				<button className={`${CLS}-dropdown-toggle dropdown-toggle btn-sm`} type="button" onClick={() => setActive(!active)}>
					{title}
				</button>
				<div className={`dropdown-menu px-1 pt-1 ${active ? 'show' : ''}`}>
					{options.map((item, index) =>
						(
							<div className="form-check mb-1" key={index}>
								<input id={`${CLS+item.key+index}`}
									type="checkbox"
									className="form-check-input"
									name={item.key}
									checked={item.checked}
									onChange={(e) => {onSelect(e, item)}}
								/>
								<label className="form-check-label" htmlFor={`${CLS+item.key+index}`}>{item.label}</label>
							</div>
						))
					}
				</div>
			</div>
		</div>
	);
};

export default ReactDropDownMulti;
